import React from 'react';
import {renderInContainer} from 'lib/domRoot';

// parse() returns host props, or null to leave the custom element in the page.

export function mountHtmlIslands({
  tag,
  parse,
  component,
  className,
  root = document
}) {
  for (const element of root.querySelectorAll(tag)) {
    const parsed = parse(element);
    if (!parsed) {
      continue;
    }

    const container = document.createElement('div');
    if (className) {
      container.className = className;
    }
    element.replaceWith(container);
    renderInContainer(React.createElement(component, parsed), container);
  }
}
